import { render, staticRenderFns } from "./CrossDomainTransitionModal.vue?vue&type=template&id=bb7f7dae&scoped=true"
import script from "./CrossDomainTransitionModal.vue?vue&type=script&lang=js"
export * from "./CrossDomainTransitionModal.vue?vue&type=script&lang=js"
import style0 from "./CrossDomainTransitionModal.vue?vue&type=style&index=0&id=bb7f7dae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7f7dae",
  null
  
)

export default component.exports